<div
  data-testid="department-avatar"
  [class]="size() === 'xs' ? '[&::before]:text-xs! [&::before]:font-medium!' : ''"
  [round]="false"
  [size]="size()"
  [style.background-color]="avatarStyle().backgroundColor"
  [style.color]="avatarStyle().textColor"
  [tuiAvatar]="initial()"></div>
